var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEssential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "avatars-academic",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.092308 3.59011l16 9.428571C57.75301 15.175881 60 19.108111 60 23.357143v17.285714c0 4.249031-2.246989 8.181261-5.907692 10.338462l-16 9.428571c-3.75944 2.215385-8.425175 2.215385-12.184616 0l-16-9.428571C6.24699 48.824119 4 44.891889 4 40.642857V23.357143c0-4.249031 2.246989-8.181261 5.907692-10.338462l16-9.428571c3.75944-2.215385 8.425175-2.215385 12.184616 0z",
    stroke: "#FFF",
    strokeWidth: 2,
    fill: "#2BD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 29.5c4.970563 0 9 4.029437 9 9v6.4375C41 46.076587 40.076587 47 38.9375 47h-13.875C23.923413 47 23 46.076587 23 44.9375V38.5c0-4.970563 4.029437-9 9-9zm0-1.5c3.58985 0 6.5-2.91015 6.5-6.5S35.58985 15 32 15s-6.5 2.91015-6.5 6.5S28.41015 28 32 28z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 30.5c3.865993 0 7 3.134007 7 7v4.4375C29 43.076587 28.076587 44 26.9375 44h-9.875C15.923413 44 15 43.076587 15 41.9375V37.5c0-3.865993 3.134007-7 7-7zm0-1.5c2.761424 0 5-2.238576 5-5s-2.238576-5-5-5-5 2.238576-5 5 2.238576 5 5 5zM41 30.5c3.865993 0 7 3.134007 7 7v4.4375C48 43.076587 47.076587 44 45.9375 44h-9.875C34.923413 44 34 43.076587 34 41.9375V37.5c0-3.865993 3.134007-7 7-7zm0-1.5c2.761424 0 5-2.238576 5-5s-2.238576-5-5-5-5 2.238576-5 5 2.238576 5 5 5z",
    fillOpacity: 0.5,
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssential);
export default __webpack_public_path__ + "static/media/essential.51c3e07cc878e4f469b71d08a16d67ea.svg";
export { ForwardRef as ReactComponent };